import { useState } from "react";

const ShareDialog = ({ model, graph, url, onClose }) => {
  const [copied, setCopied] = useState(false);
  const { games } = model;
  const topIndex = graph.topList[0];
  const best = graph.edges.reduce((m, e) => (!m || e.s > m.s ? e : m), null);
  const designerCounts = {};
  games.forEach((g) => g.designers.forEach((d) => (designerCounts[d] = (designerCounts[d] || 0) + 1)));
  const topDesigner = Object.keys(designerCounts).sort((a, b) => designerCounts[b] - designerCounts[a])[0];
  const largest = graph.clusters[0];

  const facts = [
    ["Most connected", `${games[topIndex].name} (${graph.adj[topIndex].length} links)`],
    ["Strongest pair", best ? `${games[best.a].name} + ${games[best.b].name}` : "—"],
    ["Top designer", topDesigner ? `${topDesigner} (${designerCounts[topDesigner]} games)` : "—"],
    ["Largest cluster", largest ? `${largest.name} (${largest.size})` : "—"],
  ];

  const copy = () => {
    navigator.clipboard?.writeText(url).then(() => setCopied(true), () => {});
  };

  return (
    <div className="dialog-backdrop" onClick={onClose}>
      <div className="dialog ludograph-share" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-title">Share your collection</div>
        <div className="ludograph-share-facts">
          {facts.map(([label, value]) => (
            <div key={label}>
              <div className="ludograph-stat-label">{label}</div>
              <div className="ludograph-share-value">{value}</div>
            </div>
          ))}
        </div>
        <div className="field">
          <label htmlFor="ludograph-share-url">Link includes your current weighting</label>
          <input
            id="ludograph-share-url"
            className="input"
            readOnly
            value={url}
            onFocus={(e) => e.target.select()}
          />
        </div>
        <div className="dialog-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={copy}>
            {copied ? "Copied" : "Copy link"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareDialog;
